import { render, staticRenderFns } from "./SeminarRowCertificate.vue?vue&type=template&id=c88bc1fc&scoped=true"
import script from "./SeminarRowCertificate.vue?vue&type=script&lang=js"
export * from "./SeminarRowCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88bc1fc",
  null
  
)

export default component.exports